export default __webpack_public_path__ + "static/media/doc.c0ab9181.svg";